<template>
    <main class="flex-1 relative pb-8 z-0 overflow-y-auto">
        <PageHeader>
            <h1 class="ml-3 text-2xl font-bold text-gray-900 sm:truncate flex flex-row justify-between w-full">
                <span>
                    <span class="flex flex-row items-center">
                        Unités
                        <Loader v-if="isUnitsFetchPending || isProjectsFetchPending"
                                class="-sm ml-2 -red"/>
                    </span>
                    <LangSwitcher />

                </span>
<!--                <router-link :to="{ name: 'unit-save' }"
                             class="flex items-center px-4 py-1 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-custom-600 hover:bg-custom-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500">
                    Créer une unité
                </router-link>-->
            </h1>
        </PageHeader>

        <div class="mt-8 w-11/12 lg:mx-auto">
            <div class="m-4">
                <Search
                    v-model="search"
                    @update:modelValue="handleSearchChange"
                />

                <Loader v-if="isUnitsFetchPending || isProjectsFetchPending" class="-sm ml-2"/>

                <div class="flex flex-col" v-else>
                    <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-6">
                        <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                            <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                                <table class="min-w-full divide-y divide-gray-200 table-fixed">
                                    <thead>
                                        <tr>
                                            <th scope="col" class="px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase w-1/6">
                                                Name
                                            </th>
                                            <th scope="col" class="px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase w-1/6">
                                                Status
                                            </th>
                                            <th scope="col" class="px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase w-1/6">
                                                Surface
                                            </th>
                                            <th scope="col" class="px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase w-1/6">
                                                Prix
                                            </th>
                                            <th scope="col" class="px-6 py-3 bg-gray-50 uppercase w-1/5">
                                                <span class="sr-only">Action(s)</span>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(unit, index) in units" :class="index%2 ? 'bg-gray-50' : 'bg-white'" :key="unit.id ? unit.id : index">
                                            <td class="px-6 py-4 text-sm text-gray-500">
                                                {{ unit.name }}
                                            </td>
                                            <td class="px-6 py-4 text-sm text-gray-500">
                                                <Select
                                                    id="status_id"
                                                    name="status_id"
                                                    :options="statusOptions"
                                                    v-model="unit.status_id"
                                                    :errors="errors.status"
                                                    @update:modelValue="handleSaveUnit(unit)"
                                                />
                                            </td>
                                            <td class="px-6 py-4 text-sm text-gray-500">
                                                <Input
                                                    id="surface"
                                                    type="number"
                                                    name="surface"
                                                    placeholder="10"
                                                    v-model="unit.surface"
                                                    :errors="errors.surface"
                                                    unit="m²"
                                                    @change="handleSaveUnit(unit)"
                                                />
                                            </td>
                                            <td class="px-6 py-4 text-sm text-gray-500">
                                                <Input
                                                    id="price"
                                                    type="number"
                                                    name="price"
                                                    placeholder="10"
                                                    v-model="unit.price"
                                                    :errors="errors.price"
                                                    unit="€"
                                                    @change="handleSaveUnit(unit)"
                                                />
                                            </td>
                                            <td class="px-6 py-4 text-right text-sm font-medium">
                                                <router-link :to="{ name: 'unit-save', params: {id: unit.id} }" class="text-indigo-600 hover:text-indigo-900 px-2">Edit</router-link>
                                                <a href="/delete" class="text-red-600 hover:text-red-900" @click.prevent="handleDeleteUnit(unit)">Delete</a>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

                <Pagination
                    v-if="lastPage > 1"
                    :current_project="currentPage"
                    :last_page="lastPage"
                    @change="handleChangePage"
                />
            </div>
        </div>
    </main>
</template>

<script>
import PageHeader from "../../components/partials/page-header";
import Loader from "../../components/partials/loader";
import LangSwitcher from "../../components/partials/lang-switcher";
import List from "../../components/partials/list"
import Pagination from "../../components/partials/pagination"
import Search from "../../components/partials/search"
import Input from "../../components/form/input"
import Select from "../../components/form/select"
import Editor from "../../components/form/editor"
import Textarea from "../../components/form/textarea"
import PROJECT_TOPOLOGY from "../../enums/project-topology";
import Switch from "../../components/form/switch"

export default {
    data() {
        return {
            search: null,
            desc: false,
            PROJECT_TOPOLOGY: PROJECT_TOPOLOGY
        }
    },
    beforeMount() {
        this.$store.dispatch('units/getList', {includes: ['status']})
        this.$store.dispatch('statuses/getList');
        this.$store.dispatch('projects/getList', {search: {'user_id': this.authUser.id }});
    },
    computed: {
        isUnitsFetchPending() {
            return this.$store.state.units.isFetchListPending
        },
        isProjectsFetchPending() {
            return this.$store.state.projects.isFetchListPending
        },
        locale() {
            return this.$store.state.config.locale;
        },
        units() {
            return this.$store.state.units.list;
        },
        lastPage() {
            return this.$store.state.units.pagination.last_page
        },
        currentPage() {
            return this.$store.state.units.pagination.current_page
        },
        errors() {
            return this.$store.state.units.errors;
        },
        statuses() {
            return this.$store.state.statuses.list;
        },
        statusOptions() {
            return this.statuses.map((status) => {
                return {label: status.translatable.name[this.locale], value: status.id}
            })
        },
        authUser() {
            return this.$store.state.auth.auth_user;
        },
        project() {
            return this.$store.state.projects.list[0];
        }
    },
    methods: {
        handleChangePage(page = this.currentPage) {
            this.$store.dispatch('units/getList', {
                'page': page,
                'sort_by': this.sort_by,
                'desc': this.desc,
                'search': this.search ? {'name': this.search} : {},
                'includes': ['status']
            });
        },
        handleSortBy(type) {
            this.desc = !this.desc;
            this.sort_by = type;

            this.handleChangePage();
        },
        handleSearchChange(search) {
            this.search = search;
            this.handleChangePage();
        },
        handleEditUnit(unit) {
            this.$store.dispatch('units/setSingle', unit)
            this.$store.dispatch('modals/open', 'unit-edit')
        },
        handleSaveUnit(unit) {
            this.$store.dispatch('units/update', {single: {
                ...unit,
                blueprints2D: [],
                blueprint3D: null,
                blueprints: null,
                description: {
                    fr: unit.translatable.description.fr,
                    en: unit.translatable.description.en,
                },
            }})
        }
    },
    components: {
        PageHeader,
        Loader,
        LangSwitcher,
        Search,
        List,
        Pagination,
        Input,
        Select,
        Editor,
        Textarea,
        Switch
    }
}
</script>
